import React, { useState, useEffect } from "react";
import ArchiveItem from "../../components/ArchiveItem/ArchiveItem";
import NoData from "../../components/NoData/NoData";
import "./Spectacle.css";

const Spectacle = () => {
  const [archives, setArchives] = useState([]);

  useEffect(() => {
    fetch("https://admin.riymay.com/api/v1/admin/get/archieves")
      .then(r => r.json())
      .then(result => { if (result.data) setArchives(result.data); })
      .catch(console.error);
  }, []);

  return (
    <div className="spectacle-container">
      <div className="spectacle-content">
        {archives.imageAudioArchives ? (
          archives.imageAudioArchives.map((item) => (
            <ArchiveItem key={item._id} item={item} type="audio" />
          ))
        ) : null}
        {archives.videoArchives ? (
          archives.videoArchives.map((video) => (
            <ArchiveItem key={video._id} item={video} type="video" />
          ))
        ) : null}
        {!archives.imageAudioArchives && !archives.videoArchives && <NoData />}
      </div>
    </div>
  );
};

export default Spectacle;
